import { useMutation } from 'react-query';
import * as taliaChatService from 'services/taliaChatService';
import { TaliaReply } from 'services/taliaChatService';

export const useSendTaliaChatMessage = (
  onSuccess?: (reply: TaliaReply) => void,
  onError?: (error: any) => void,
  options = {}
) => {
  return useMutation(taliaChatService.sendTaliaChatMessage, {
    onSuccess,
    onError,
    ...options,
  });
};

export const useClearTaliaChat = (
  onSuccess?: () => void,
  onError?: (error: any) => void,
  options = {}
) => {
  return useMutation(taliaChatService.clearTaliaChat, {
    onSuccess,
    onError,
    ...options,
  });
};
